import { UNITS } from "../../constants/units";

export const getValueWithUnit = (value: number, unit: UNITS): string => {
  switch (unit) {
    case UNITS.GRAMS:
      if (value >= 1000) {
        return `${Math.round(value / 1000)}${UNITS.KILO}`;
      }
      return `${Math.round(value)}${UNITS.GRAMS}`;
    case UNITS.KILO:
      if (value < 1) {
        return `${Math.round(value * 1000)}${UNITS.GRAMS}`;
      }
      if (value >= 1000) {
        return `${Math.round(value / 1000)}${UNITS.TON}`;
      }
      return `${Math.round(value)}${UNITS.KILO}`;
    case UNITS.TON:
      if (value < 1) {
        return `${Math.round(value * 1000)}${UNITS.KILO}`;
      }
      return `${Math.round(value)}${UNITS.TON}`;
    case UNITS.MILLILITER:
      if (value >= 1000) {
        return `${Math.round(value / 1000)}${UNITS.LITER}`;
      }
      return `${Math.round(value)}${UNITS.MILLILITER}`;
    case UNITS.LITER:
      if (value < 1) {
        return `${Math.round(value * 1000)}${UNITS.MILLILITER}`;
      }
      return `${Math.round(value)}${UNITS.LITER}`;
    case UNITS.PERCENT:
      return `${Math.round(value)}${UNITS.PERCENT}`;
    default:
      return "";
  }
};
